(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1312],{

/***/ 80029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ GoogleSignInButton; }
/* harmony export */ });
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1025);
/* harmony import */ var antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_button_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65400);
/* harmony import */ var antd_lib_space_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54277);
/* harmony import */ var antd_lib_space_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(antd_lib_space_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd_lib_space__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74048);
/* harmony import */ var antd_lib_image_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47811);
/* harmony import */ var antd_lib_image_style__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(antd_lib_image_style__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var antd_lib_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91633);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var GoogleSignInButton = function GoogleSignInButton(_ref) {
  var text = _ref.text,
      handleSignIn = _ref.handleSignIn;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd_lib_button__WEBPACK_IMPORTED_MODULE_4__["default"], {
    className: "bg-gray-100 text-gray-700 border-none text-sm",
    block: true,
    size: "large",
    onClick: handleSignIn,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(antd_lib_space__WEBPACK_IMPORTED_MODULE_5__["default"], {
      direction: "horizontal",
      align: "center",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd_lib_image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        preview: false,
        style: {
          width: 32
        },
        className: "inline-block",
        src: "/thirdParties/google_g.png"
      }), text]
    })
  });
};

/***/ }),

/***/ 18715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignInOrDemo_SignInOrDemo; }
});

// EXTERNAL MODULE: ./node_modules/antd/lib/row/style/index.js
var style = __webpack_require__(30467);
// EXTERNAL MODULE: ./node_modules/antd/lib/row/index.js
var row = __webpack_require__(55673);
// EXTERNAL MODULE: ./node_modules/antd/lib/divider/style/index.js
var divider_style = __webpack_require__(56120);
// EXTERNAL MODULE: ./node_modules/antd/lib/divider/index.js
var divider = __webpack_require__(74253);
// EXTERNAL MODULE: ./node_modules/antd/lib/col/style/index.js
var col_style = __webpack_require__(58136);
// EXTERNAL MODULE: ./node_modules/antd/lib/col/index.js
var col = __webpack_require__(5789);
// EXTERNAL MODULE: ./node_modules/antd/lib/card/style/index.js
var card_style = __webpack_require__(89626);
// EXTERNAL MODULE: ./node_modules/antd/lib/card/index.js
var card = __webpack_require__(70302);
// EXTERNAL MODULE: ./node_modules/antd/lib/typography/style/index.js
var typography_style = __webpack_require__(23461);
// EXTERNAL MODULE: ./node_modules/antd/lib/typography/index.js
var typography = __webpack_require__(53740);
// EXTERNAL MODULE: ./src/components/GoogleSignInButton/GoogleSignInButton.js
var GoogleSignInButton = __webpack_require__(80029);
// EXTERNAL MODULE: ./node_modules/antd/lib/button/style/index.js
var button_style = __webpack_require__(1025);
// EXTERNAL MODULE: ./node_modules/antd/lib/button/index.js
var lib_button = __webpack_require__(65400);
// EXTERNAL MODULE: ./node_modules/antd/lib/form/style/index.js
var form_style = __webpack_require__(29809);
// EXTERNAL MODULE: ./node_modules/antd/lib/form/index.js
var lib_form = __webpack_require__(97538);
// EXTERNAL MODULE: ./node_modules/antd/lib/input/style/index.js
var input_style = __webpack_require__(89858);
// EXTERNAL MODULE: ./node_modules/antd/lib/input/index.js
var input = __webpack_require__(51024);
// EXTERNAL MODULE: ./node_modules/antd/lib/message/style/index.js
var message_style = __webpack_require__(75314);
// EXTERNAL MODULE: ./node_modules/antd/lib/message/index.js
var message = __webpack_require__(11187);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 6 modules
var esm = __webpack_require__(5233);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/index.js
var services = __webpack_require__(72220);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/SignInOrDemo/CollectEmailForDemo.js















var CollectEmailForDemo = function CollectEmailForDemo(_ref) {
  var handleDemoClick = _ref.handleDemoClick;

  var _useState = (0,react.useState)(false),
      showEmailForm = _useState[0],
      setShowEmailForm = _useState[1];

  var _useTranslation = (0,esm/* useTranslation */.$G)('signup'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showEmailForm && /*#__PURE__*/(0,jsx_runtime.jsxs)(lib_form/* default */.Z, {
      onFinish: function onFinish(values) {
        services/* ApiCall.WaitList.demoSignUp */.o.WaitList.demoSignUp(values).then(function () {
          handleDemoClick();
        })["catch"](function (error) {
          message["default"].error('An error occurred. Please try again.');
        });
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib_form/* default.Item */.Z.Item, {
        name: "email",
        label: t('email'),
        rules: [{
          required: true,
          message: t('email_required')
        }, {
          type: 'email',
          message: t('email_invalid')
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(input["default"], {
          type: "email"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib_button["default"], {
        className: "bg-g400 text-white",
        htmlType: "submit",
        children: t('start_demo')
      })]
    }), !showEmailForm && /*#__PURE__*/(0,jsx_runtime.jsx)(lib_button["default"], {
      className: " bg-g400 text-white",
      onClick: function onClick() {
        return setShowEmailForm(true);
      },
      children: t('demo_or_signup_cta')
    })]
  });
};

/* harmony default export */ var SignInOrDemo_CollectEmailForDemo = (CollectEmailForDemo);
;// CONCATENATED MODULE: ./src/components/SignInOrDemo/SignInOrDemo.js
















var SignInOrDemo = function SignInOrDemo(_ref) {
  var handleSignIn = _ref.handleSignIn,
      handleDemoClick = _ref.handleDemoClick;

  var _useTranslation = (0,esm/* useTranslation */.$G)('signup'),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    id: "demo",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
      align: "middle",
      justify: "center",
      className: "h-screen p-4",
      gutter: 24,
      style: {
        display: 'flex',
        justifyContent: 'center'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        xs: 24,
        sm: 10,
        lg: 8,
        xl: 6,
        style: {
          display: 'flex',
          justifyContent: 'center'
        },
        className: "text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(card/* default */.Z, {
          style: {
            width: '100%',
            maxWidth: '400px',
            height: 'auto',
            minHeight: '340px',
            alignItems: 'center'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Title */.Z.Title, {
            level: 3,
            children: t('demo_or_signup_title')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Paragraph */.Z.Paragraph, {
            children: t('demo_or_signup_description')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignInOrDemo_CollectEmailForDemo, {
            handleDemoClick: handleDemoClick
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
        xs: 0,
        sm: 2,
        lg: 1,
        xl: 1,
        style: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        },
        className: "text-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(divider/* default */.Z, {
          type: "vertical",
          style: {
            height: '40%',
            minHeight: '150px'
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          style: {
            fontWeight: 'bold',
            color: '#333',
            margin: '4px',
            fontSize: '18px',
            padding: '0 8px'
          },
          children: t('or')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(divider/* default */.Z, {
          type: "vertical",
          style: {
            height: '40%',
            minHeight: '150px'
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
        xs: 24,
        sm: 10,
        lg: 8,
        xl: 6,
        style: {
          display: 'flex',
          justifyContent: 'center'
        },
        className: "text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(card/* default */.Z, {
          style: {
            width: '100%',
            maxWidth: '400px',
            height: 'auto',
            minHeight: '340px'
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography/* default.Title */.Z.Title, {
            level: 3 // className="text-xl font-semibold text-center"
            ,
            children: t('demo_or_signup_traqqie_users')
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(row/* default */.Z, {
            align: "middle",
            justify: "center",
            className: "px-4",
            gutter: [16, 24],
            children: [t('demo_or_signup_member_explanation'), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
              span: 24,
              className: "text-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleSignInButton/* GoogleSignInButton */.N, {
                handleSignIn: handleSignIn,
                text: t('login_with_google').toUpperCase()
              })
            }), t('or'), /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
              span: 24,
              className: "text-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(GoogleSignInButton/* GoogleSignInButton */.N, {
                handleSignIn: handleSignIn,
                text: t('signup_with_google').toUpperCase()
              })
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var SignInOrDemo_SignInOrDemo = (SignInOrDemo);

/***/ }),

/***/ 43381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ generateAlternatesAndCanonical; }
/* harmony export */ });
/* unused harmony export LANDINGPAGE */
var LANDINGPAGE = {
  title: 'Increase WBSO Claims by 60% - Automate WBSO Time Tracking with Traqqie',
  description: 'Eliminate the chase for engineer timesheets and streamline your WBSO submissions with Traqqie. Our automated platform boosts your claims by 60%, ensures compliance, and saves significant time. Discover how Traqqie can transform your subsidy management and let you focus on innovation.'
};
var generateAlternatesAndCanonical = function generateAlternatesAndCanonical(locale) {
  var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var DEFAULT_LANGUAGE = 'en';
  var supportedLanguages = [{
    lang: 'en',
    path: '/en'
  }, {
    lang: 'nl',
    path: '/nl'
  }, {
    lang: 'x-default',
    path: ''
  } // Add more languages as needed
  ]; // Assuming your site's base URL is example.com

  var baseUrl = 'https://traqqie.com'; // Generate the language alternates array

  return {
    alternates: supportedLanguages.map(function (_ref) {
      var lang = _ref.lang,
          path = _ref.path;
      return {
        hrefLang: lang,
        href: route === undefined ? "".concat(baseUrl).concat(path) : "".concat(baseUrl).concat(path, "/").concat(route) // Adjust the path as necessary

      };
    }),
    canonoical: locale !== DEFAULT_LANGUAGE ? "".concat(baseUrl, "/").concat(locale, "/").concat(route === undefined ? '' : "".concat(route)) : "".concat(baseUrl, "/").concat(route === undefined ? '' : "".concat(route))
  };
};

/***/ }),

/***/ 1396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SignInPageLocalized": function() { return /* binding */ SignInPageLocalized; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ sign_in; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/components/index.js + 17 modules
var components = __webpack_require__(87478);
// EXTERNAL MODULE: ./src/components/SignInOrDemo/SignInOrDemo.js + 1 modules
var SignInOrDemo = __webpack_require__(18715);
// EXTERNAL MODULE: ./src/data/seo/seo.js
var seo = __webpack_require__(43381);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./src/utils/pages.js
var pages = __webpack_require__(34052);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/SignInPage/SignInPage.js














var SignInPage = function SignInPage(_ref) {
  var locale = _ref.locale;
  var router = (0,next_router.useRouter)();

  var _useAuth = (0,components/* useAuth */.aC)(),
      signInWithGoogleAccount = _useAuth.signInWithGoogleAccount,
      authUser = _useAuth.authUser,
      createDemoAccount = _useAuth.createDemoAccount;

  var _useState = (0,react.useState)(false),
      keepLoggedIn = _useState[0],
      setKeepLoggedIn = _useState[1];

  var _useTranslation = (0,es/* useTranslation */.$G)('signup'),
      t = _useTranslation.t;

  (0,react.useEffect)(function () {
    if (authUser) {
      if ((authUser === null || authUser === void 0 ? void 0 : authUser.has_access_application) & !(authUser !== null && authUser !== void 0 && authUser.has_access_admin)) {
        router.push(pages/* PAGE.wbsoAppDashboard */.qX.wbsoAppDashboard);
      } else if (authUser !== null && authUser !== void 0 && authUser.has_access_admin) {
        router.push(pages/* PAGE.dashboard */.qX.dashboard);
      } else {
        // User has no access to any protected pages
        message.error('You do not have access to any protected pages. If you think this is an error, please contact support ( support@traqqie.com ).', {
          duration: 2500
        });
      }
    }
  }, [authUser]);

  var handleSignIn = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator["default"])( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var user;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return signInWithGoogleAccount({
                keepLoggedIn: keepLoggedIn
              });

            case 2:
              user = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSignIn() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('sign_in_meta_title'),
      description: t('sign_in_meta_title'),
      openGraph: {
        title: t('sign_in_meta_title'),
        description: t('sign_in_meta_title')
      },
      languageAlternates: (0,seo/* generateAlternatesAndCanonical */.w)(locale, 'sign-in').alternates,
      canonical: (0,seo/* generateAlternatesAndCanonical */.w)(locale, 'sign-in').canonoical
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SignInOrDemo/* default */.Z, {
      handleSignIn: handleSignIn,
      handleDemoClick: createDemoAccount
    })]
  });
};

/* harmony default export */ var SignInPage_SignInPage = (SignInPage);
;// CONCATENATED MODULE: ./src/pages/sign-in.js


var __N_SSP = true;
var SignInPageLocalized = function SignInPageLocalized(_ref) {
  var locale = _ref.locale;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(SignInPage_SignInPage, {
    locale: locale
  });
};
/* harmony default export */ var sign_in = (SignInPageLocalized);

/***/ }),

/***/ 72220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* reexport safe */ _ApiCall__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _ApiCall__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78611);
/* harmony import */ var _Fetcher__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8210);



/***/ }),

/***/ 16069:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-in",
      function () {
        return __webpack_require__(1396);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1522,2962,5932,9774,2888,179], function() { return __webpack_exec__(16069); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);